export default {
      id: "cancel-usage",
      viewBox: "0 0 149.497 149.661",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#cancel",
      toString: function () {
        return this.url;
      }
    }